import OncolensLogoWithText from '@/assets/OncolensLogoWithText.svg';
import * as React from 'react';
import LoginForm from '../components/LoginForm';
import { useEffect } from "react";

function DemoLogin() {
  const referenceCode = 'oldemo';

  useEffect(() => {
    localStorage.setItem('lastOrgReferenceCode', referenceCode);
  }, []);
  
  return (
    <div className="flex flex-col justify-center min-h-screen bg-gray-50 sm:px-6 lg:px-8">
      <LoginForm
        orgReferenceCode={referenceCode}
        bannerLogoPath={OncolensLogoWithText}
        primaryColor="#FD8151"
        bannerLogoAlt={'Oncolens Logo'}
        allowSignUp={true}
        showPoweredBy={false}
      />
    </div>
  );
}

export { DemoLogin };
